import { useAct } from 'FlowBuilder/store'
import TextField from 'Shared/components/TextField'
import CheckboxField from 'Shared/components/CheckboxField'
import SelectField from 'Shared/components/SelectField'

export default function PageSettingsForm() {
  const act = useAct()
  const [templateFieldErrors, setTemplateFieldErrors] = useState({})

  const { id, slug, settings } = useSel(s => s.builder?.flow || {})
  const errors = useSel(s => s.local.errors?.flow || {})
  const isEditingTemplate = useSel((s) => s.local.isEditingTemplate)

  const templateFields = useSel(s =>
    (s.builder.flowTemplate?.fields || []).filter(f => f.setup)
  )

  const templateFieldValues = useSel(s => s.builder.flow.templateFields)

  function settingUpdater(key) {
    return (value) => {
      act.builder.updateFlowSetting(key, value)
    }
  }

  const createTemplateFieldHandler = (field) => (value) => {
    setTemplateFieldErrors(prev => ({
      ...prev,
      [field.slug]: null
    }))

    if (field.numberOnly && value && !/^\d*$/.test(value)) {
      setTemplateFieldErrors(prev => ({
        ...prev,
        [field.slug]: 'Please enter numbers only'
      }))
      return
    }

    act.builder.setTemplateField({ slug: field.slug, value })
  }

  return (
    <form>
      {!isEditingTemplate && <TextField
        label="Page URL slug"
        value={slug}
        onChange={(value) => { act.builder.updateFlow('slug', value) }}
        error={errors.slug}
      />}

      <TextField
        label="Submit button text"
        value={settings.buttonTextSubmit}
        onChange={settingUpdater('buttonTextSubmit')}
      />

      {templateFields.map((field) => {
        const value = templateFieldValues[field.slug]
        const handleChange = createTemplateFieldHandler(field)
        const fieldError = templateFieldErrors[field.slug]

        if (field.questionType === 'text')
          return <TextField key={field.slug} label={field.label} value={value} onChange={handleChange} error={fieldError} />
        if (field.questionType === 'checkbox')
          return <CheckboxField key={field.slug} label={field.label} value={value} onChange={handleChange} />
        if (field.questionType === 'select')
          return <SelectField key={field.slug} label={field.label} value={value} onChange={handleChange} options={field.options} />
        return null
      })}
    </form>
  )
}
